<ngx-spinner
  [color]="primaryColor"
  [fullScreen] = "false"
  bdColor = "transparent"
  size = "default"
  type="ball-clip-rotate-multiple">
  <p style="font-size: 14px; color: white">Loading...</p>
</ngx-spinner>

<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="mobileQuery.matches ? 'over' : 'side'" [opened]="routerService.isAuthRoute()">
    <a routerLink="/dashboard">
      <img src="./assets/images/logo.png" class="logo" alt="SiteSoft New Zealand Ltd" />
    </a>

    <mat-nav-list dense>
      <h3 matSubheader *ngIf="app.isAuthenticated">Main Account</h3>

      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="dashboard" *ngIf="app.isAuthenticated">
        <span class="menu-panel-text">Dashboard</span>
      </a>
      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="sites" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          app.userCan('manage_sites')">
        <span class="menu-panel-text"> {{ utils.getLangTerm('sites.plural', 'Sites') }} </span>
      </a>
      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="contractors" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          app.userCan('manage_contractors')">
        <span class="menu-panel-text">{{ utils.getLangTerm('contractors.plural', 'Contractors') }}</span>
      </a>
      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="employees" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          app.userCan('manage_employees')">
        <span class="menu-panel-text">{{ utils.getLangTerm('employees.plural', 'Employees') }}</span>
      </a>
      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="visitors" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          app.userCan('manage_visitors')">
        <span class="menu-panel-text">Visitors</span>
      </a>
      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="sssp" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          app.userCan('manage_sssp')">
        <span class="menu-panel-text">{{ utils.getLangTerm('safety-plans.plural', 'Safety Plans') }}</span>
      </a>
      <a mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['courses']" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          app.userCan('manage_inductions')">
        <span class="menu-panel-text">Inductions</span>
      </a>
      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="incidents" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          app.userCan('manage_incidents')">
        <span class="menu-panel-text">Incidents</span>
      </a>
      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="actions" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          app.userCan('manage_tasks')">
        <span class="menu-panel-text">Tasks</span>
      </a>

      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="safety-observations" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          app.userCan('manage_safety_observations')">
        <span class="menu-panel-text">Safety Observations</span>
      </a>

      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="tools" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          app.userCan('manage_tools')">
        <span class="menu-panel-text">Tools</span>
      </a>

      <mat-expansion-panel class="mat-elevation-z" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          app.userCan('manage_assets')">
        <mat-expansion-panel-header>
          <mat-panel-title id="assets"><span class="submenu-panel-header">Assets</span></mat-panel-title>
        </mat-expansion-panel-header>

        <mat-nav-list dense>
<!--          <a mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['/assets', 'events-calendar']" *ngIf="-->
<!--              app.userAccountLink.permissions != 'Employee' &&-->
<!--              app.isAuthenticated &&-->
<!--              app.userCan('manage_assets')">-->
<!--            <span class="submenu-panel-text">Events Calendar</span>-->
<!--          </a>-->
          <a mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['asset-register']" *ngIf="
              app.userAccountLink.permissions != 'Employee' &&
              app.isAuthenticated &&
              app.userCan('manage_assets')">
            <span class="submenu-panel-text">Asset Register</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['asset-types']" *ngIf="
              app.userAccountLink.permissions != 'Employee' &&
              app.isAuthenticated &&
              app.userCan('manage_assets')">
            <span class="submenu-panel-text">Asset Types</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['vendors']" *ngIf="
              app.userAccountLink.permissions != 'Employee' &&
              app.isAuthenticated &&
              app.userCan('manage_assets')">
            <span class="submenu-panel-text">Vendors</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>

      <mat-expansion-panel class="mat-elevation-z" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          app.userCan('manage_dynamic_forms')">
        <mat-expansion-panel-header>
          <mat-panel-title id="dynamic-forms"><span class="submenu-panel-header">Forms</span></mat-panel-title>
        </mat-expansion-panel-header>

        <mat-nav-list dense>
          <a mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['dynamic-forms']" *ngIf="
              app.userAccountLink.permissions != 'Employee' &&
              app.isAuthenticated &&
              app.userCan('manage_dynamic_forms')">
            <span class="submenu-panel-text">Form Templates</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['dynamic-forms-categories']" *ngIf="
              app.userAccountLink.permissions != 'Employee' &&
              app.isAuthenticated &&
              app.userCan('manage_dynamic_forms')">
            <span class="submenu-panel-text">Form Categories</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" [routerLink]="['dynamic-forms-assigned']" *ngIf="
              app.userAccountLink.permissions != 'Employee' &&
              app.isAuthenticated &&
              app.userCan('manage_dynamic_forms')">
            <span class="submenu-panel-text">Assigned Forms</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>

      <mat-expansion-panel class="mat-elevation-z" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          (app.userCan('manage_sssp') ||
            app.userCan('manage_task_analysis') ||
            app.userCan('manage_hazardous_substances') ||
            app.userCan('manage_hazards') ||
            app.userCan('manage_erps') ||
            app.userCan('manage_toolbox_talks'))">
        <mat-expansion-panel-header>
          <mat-panel-title id="templates"><span class="submenu-panel-header">Templates</span></mat-panel-title>
        </mat-expansion-panel-header>

        <mat-nav-list dense>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="hazards"
            *ngIf="app.userCan('manage_hazards')">
            <span class="submenu-panel-text">Hazards & Risks</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="hazardous_substances"
            *ngIf="app.userCan('manage_hazardous_substances')">
            <span class="submenu-panel-text">{{ utils.getLangTerm('hazardous-substances.list.account-title', 'Hazardous Substances') }}</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="task-analysis">
            <span class="submenu-panel-text">{{ utils.getLangTerm('task_analysis_documents.list.title', 'Task Analysis Documents') }} <i>(Legacy)</i> </span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="task-analyses-revised">
            <span class="submenu-panel-text">{{ utils.getLangTerm('ta-jsa-swms.list.account-title', 'TA/JSA/SWMS') }}</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="folders" *ngIf="
              app.userAccountLink.permissions != 'Employee' &&
              app.isAuthenticated &&
              app.userCan('manage_documents')">
            <span class="submenu-panel-text">Documents</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="prequalifications"
            [routerLinkActiveOptions]="{ exact: true }" *ngIf="
              app.userAccountLink.permissions != 'Employee' &&
              app.userCan('manage_prequalifications')">
            <span class="submenu-panel-text">{{ utils.getLangTerm('contractors.singular', 'Contractor') }} Pre-Qualifications</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="audits-templates">
            <span class="submenu-panel-text">Inspection/Audit Templates</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="audit-items-template">
            <span class="submenu-panel-text">Inspection/Audit Questions</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="toolbox-talks-templates">
            <span class="submenu-panel-text">{{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }} Templates</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>

      <mat-expansion-panel class="mat-elevation-z" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated &&
          (
            app.userCan('view_access_records') ||
            app.userCan('view_onsite_records') ||
            app.userCan('view_time_onsite_records') ||
            (app.userCan('view_pandemic_records') && app.account.pandemic_enabled)
          )">
        <mat-expansion-panel-header>
          <mat-panel-title id="reports"><span class="submenu-panel-header">Reports</span></mat-panel-title>
        </mat-expansion-panel-header>

        <mat-nav-list dense>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="reports/access-records"
            *ngIf="app.userCan('view_access_records')">
            <span class="submenu-panel-text">Sign In/Out</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="reports/onsite-records"
            *ngIf="app.userCan('view_onsite_records')">
            <span class="submenu-panel-text">Currently Onsite</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="reports/time-onsite-records"
            *ngIf="app.userCan('view_time_onsite_records')">
            <span class="submenu-panel-text">Time Spent Onsite</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="reports/pandemic-records"
            *ngIf="app.userCan('view_pandemic_records') && app.account.pandemic_enabled">
            <span class="submenu-panel-text">Covid-19 Records</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="audits">
            <span class="submenu-panel-text">Inspections & Audits</span>
          </a>
          <a mat-list-item routerLinkActive="active-submenu-item" routerLink="toolbox-talks">
            <span class="submenu-panel-text">{{ utils.getLangTerm('toolbox-talks.plural', 'Toolbox Talks') }}</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>

      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="messages"
        *ngIf="app.isAuthenticated && app.userAccountLink.permissions != 'Employee'">
        <span class="menu-panel-text">Messages</span>
      </a>

      <h3 matSubheader *ngIf="app.isAuthenticated">
        {{ utils.getLangTerm('contractors.singular', 'Contractor') }} Accounts <br>
        (for {{ utils.getLangTerm('contractors.singular', 'Contractor').toLowerCase() }} use only)
      </h3>

      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="user/accessible-sites" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated">
        <span class="menu-panel-text">PCBU1 {{ utils.getLangTerm('sites.plural', 'Sites') }}</span>
      </a>

      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="my-prequalifications" *ngIf="
          app.userAccountLink.permissions != 'Employee' &&
          app.isAuthenticated">
        <span class="menu-panel-text">PCBU1 Pre-Qualifications</span>
      </a>

      <a mat-list-item routerLinkActive="active-submenu-item" routerLink="sign-in" *ngIf="!app.isAuthenticated">
        <span class="menu-panel-text">Login</span>
      </a>

    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-top-nav [sidenav]="sidenav"></app-top-nav>

    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-modal></app-modal>
<app-toast></app-toast>

<!-- toggleable overlay with a spinner -->
<tour-step-template></tour-step-template>
